import { render } from "./ContactsPeopleInEntityView.vue?vue&type=template&id=e1818d62&scoped=true"
import script from "./ContactsPeopleInEntityView.vue?vue&type=script&lang=js"
export * from "./ContactsPeopleInEntityView.vue?vue&type=script&lang=js"

import "./ContactsPeopleInEntityView.vue?vue&type=style&index=0&id=e1818d62&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1818d62"]])

export default __exports__